// หน้าถอนเงิน (ยกตรรกะมาจาก Starbet999 main.js: submitwithdraw + กันกดรัว)
import React, { Component } from 'react';
import jwt_decode from 'jwt-decode';
import instance from '../axios-instance';
import Systems from '../SystemFunction';
import { toast } from './toast';
import { t } from './i18n';

const GUARD_KEY = 'withdraw_spam_guard';
const AMOUNTS = [100, 300, 500, 1000, 3000, 5000, 10000, 30000, 50000];

export default class Withdraw extends Component {
  state = { amount: '', loading: false, cooldown: 0 };

  componentDidMount() {
    const g = this.guard();
    if (g?.lockUntil && Date.now() < g.lockUntil) this.startCooldown(Math.ceil((g.lockUntil - Date.now()) / 1000));
  }
  componentWillUnmount() { clearInterval(this.timer); }

  tr = (k) => t(this.props.language || 'th', k);
  guard() { try { return JSON.parse(localStorage.getItem(GUARD_KEY)); } catch { return null; } }

  startCooldown(sec) {
    clearInterval(this.timer);
    this.setState({ cooldown: sec });
    this.timer = setInterval(() => {
      this.setState((s) => {
        if (s.cooldown <= 1) { clearInterval(this.timer); localStorage.removeItem(GUARD_KEY); return { cooldown: 0 }; }
        return { cooldown: s.cooldown - 1 };
      });
    }, 1000);
  }

  pick = (v) => {
    if (v > Number(this.props.balance || 0)) return toast.warning(this.tr('insufficient_withdraw'));
    this.setState({ amount: String(v) });
  };

  submit = async (e) => {
    e.preventDefault();
    const tr = this.tr;
    const g = this.guard();
    if (g?.lockUntil && Date.now() < g.lockUntil) {
      return toast.warning(tr('mh_wait_seconds').replace('{s}', Math.ceil((g.lockUntil - Date.now()) / 1000)));
    }
    const clickCount = (g?.clickCount || 0) + 1;
    localStorage.setItem(GUARD_KEY, JSON.stringify({ ...(g || {}), clickCount }));
    if (clickCount > 5) {
      localStorage.setItem(GUARD_KEY, JSON.stringify({ lockUntil: Date.now() + 100000, clickCount }));
      this.startCooldown(100);
      return toast.warning(tr('mh_too_many'));
    }

    const amount = parseFloat(this.state.amount);
    const balance = parseFloat(this.props.balance || 0);
    const minW = parseFloat(this.props.minwithdraw || 10);
    if (!(amount > 0) || amount > balance) return toast.warning(tr('insufficient_withdraw'));
    if (amount < minW) return toast.warning(`${tr('min_withdraw_prefix')} ${minW} ${tr('baht')}`);

    const token = localStorage.getItem('auth_token');
    if (!token) return toast.error(tr('withdraw_problem'));
    const Username = jwt_decode(token).message.playerid;

    this.setState({ loading: true });
    try {
      const res = await instance.post('/api/v1/userwithdraw',
        { User_id: Username, System: Systems, amount: this.state.amount },
        { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.status === 200) {
        localStorage.removeItem(GUARD_KEY);
        toast.success(tr('withdraw_success'));
        this.setState({ amount: '' });
        this.props.onDone && this.props.onDone();
      } else if (res.data.status === 203) {
        toast.error(`${tr('turnover_remaining_prefix')} ${res.data.amountturnover} ${tr('baht')}`);
      } else if (res.data.status === 207) {
        toast.error(`${tr('min_withdraw_prefix')} ${res.data.maxwithdraw} ${tr('baht')}`);
      } else {
        toast.error(res.data.message || tr('withdraw_error'));
      }
    } catch (err) {
      toast.error(tr('mh_system_error'));
    }
    this.setState({ loading: false });
  };

  render() {
    const tr = this.tr;
    const { balance, accnumber } = this.props;
    const acc = Array.isArray(accnumber) ? accnumber[0] : null;
    const { amount, loading, cooldown } = this.state;
    return (
      <div className="mh-withdraw">
        <h3 className="mh-title">{tr('withdraw_title')}</h3>

        <div className="mh-card mh-balance-card">
          <span>{tr('available_balance')}</span>
          <strong>{Number(balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
        </div>

        <div className="mh-card">
          <div className="mh-label">{tr('withdraw_to')}</div>
          {acc ? (
            <div className="mh-bank">
              {acc.img_path && <img src={acc.img_path} alt="" />}
              <div>
                <div className="mh-bank-no">{acc.accno}</div>
                <div className="mh-muted">{acc.fullname_th}</div>
              </div>
            </div>
          ) : <div className="mh-muted">{tr('no_bank_account')}</div>}
        </div>

        <form className="mh-card" onSubmit={this.submit}>
          <label className="mh-label" htmlFor="mh_withdraw_amount">{tr('withdraw_amount')}</label>
          <input id="mh_withdraw_amount" className="mh-input" inputMode="decimal" placeholder="0"
            value={amount} onChange={(e) => this.setState({ amount: e.target.value.replace(/[^\d.]/g, '') })} />
          <div className="mh-label">{tr('select_amount')}</div>
          <div className="mh-amounts">
            {AMOUNTS.map((v) => (
              <button type="button" key={v} className={String(v) === amount ? 'is-active' : ''} onClick={() => this.pick(v)}>
                {v.toLocaleString()}
              </button>
            ))}
          </div>
          <button type="submit" className="mh-btn mh-btn-primary" disabled={loading || cooldown > 0}>
            {loading ? '…' : tr('confirm_withdraw')}
          </button>
          {cooldown > 0 && <div className="mh-warn">{tr('mh_wait_seconds').replace('{s}', cooldown)}</div>}
        </form>
      </div>
    );
  }
}
